import { token } from '@atlaskit/tokens';
import Z_INDEX from '@databases/layout/z-index';
import { HALF_ROW_SELECT_BUTTON_WIDTH } from '@databases/utils/constants';
import { encodeCssUrl } from '@databases/utils/utils';
import svgToMiniDataURI from 'mini-svg-data-uri';
import React, { FunctionComponent, useMemo } from 'react';

import { getSkeletonRowSvg } from '../../../lazy-render';

import { StyledEntryNumberTd } from './EntryNumber';
import useHasNumberedEntries from './UseHasNumberedEntries';

interface EntrySkeletonProps {
  contentId: string;
  index: number;
  fieldCount: number;
  row: { type: 'gap'; height: number };
  columnWidths: number[];
}

const EntrySkeleton: FunctionComponent<EntrySkeletonProps> = ({
  contentId,
  index,
  fieldCount,
  row,
  columnWidths,
}) => {
  const hasNumberedEntries = useHasNumberedEntries({ contentId, scope: 'main' });

  const skeletonSvg = useMemo(
    () => svgToMiniDataURI(getSkeletonRowSvg(columnWidths.slice(1))),
    [columnWidths]
  );

  return (
    <tr
      style={{
        background: 'transparent',
        left: HALF_ROW_SELECT_BUTTON_WIDTH,
      }}
    >
      {/* Entry selector gap */}
      <div
        style={{
          position: 'sticky',
          zIndex: Z_INDEX.ROW_SELECT_BUTTON,
          width: HALF_ROW_SELECT_BUTTON_WIDTH,
          border: 'none',
          left: 0,
          background: token('color.background.input.pressed'),
        }}
      />
      {hasNumberedEntries && (
        <StyledEntryNumberTd
          className="entry-number-table-data"
          hasNumberedEntries={hasNumberedEntries}
        >
          {index + 1}
        </StyledEntryNumberTd>
      )}
      <td
        colSpan={fieldCount}
        style={{
          gridColumn: hasNumberedEntries ? '3 / -1' : '2 / -1',
          height: row.height,
          background: `url(${encodeCssUrl(skeletonSvg)}) repeat-y`,
          borderLeft: 'none',
        }}
      />
    </tr>
  );
};

export default EntrySkeleton;
